const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-aeapps-resources-manager/shared/api/InfoPresentersRegister");